import {
  CloudUploadOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  CommandBar,
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  PivotLinkSize,
  Link,
  ProgressIndicator,
} from "@fluentui/react";
import {
  Button,
  DatePicker,
  Space,
  Form,
  Tooltip,
  Layout,
  Input,
  Radio,
  notification,
  message,
  Drawer,
  Badge,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import React, { useContext, useState } from "react";
import moment from "moment";
import { Save, X } from "react-feather";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
import { observer } from "mobx-react-lite";
import { NaocDailyProductionForm } from "./NaocDailyProductionForm";
import { ENV } from "../../../Infrastructure/EnvironmentConfig";

import { ErrorLogs } from "./ErrorLogs";
import { ManualFormEntry } from "./ManualFormEntry";

const { Content, Sider } = Layout;
const _ = require("underscore");
const initData = {
  akriGasInjToOGutaPlant: 0,
  akriGasToOGutaPlant: 0,
  beniboyeOilDailyMetered: 0,
  dailyFuelGasToEPCL: 0,
  dailyGasDeliveryToBonny: 0,
  dailyGasDeliveryToRSIPP: 0,
  dailyGasEPCLFertPLT: 0,
  dailyGasJVIPP: 0,
  kwaleGpGasInj: 0,
  landAreaGas: 0,
  landAreaOil: 0,
  naocDailyProductionId: 0,
  nglDelivered: 0,
  gasInternallyUtilizedforNGL: 0,
  nglProduced: 0,
  obGpGasInj: 0,
  productionDate: new Date(),
  swampAreaRemarks: "",
  landAreaRemarks: "",
  swampAreaGas: 0,
  swampAreaOil: 0,
  totalGasEvacuated: 0,
  totalGasFlared: 0,
  totalGasInternallyUtilized: 0,
  totalGasProduced: 0,
  totalGasRecKwaleGp: 0,
  totalGasRecOBGp: 0,

  totalOilMeteredProd: 0,
  totalOilProduced: 0,
};
export const NaocDailyProductionUpload = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const uploadprops = {
    name: "file",
    accept: ".xls,.xlsx",
    multiple: false,
    beforeUpload: (file, fileList) => {
      if (_.isEmpty(naocDailyProductionStore.sheetName)) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description:
            "input deck sheet name is required,enter the flash production report sheetname",
        });

        return false;
      }
      return true;
    },
    headers: {
      method: "Post",
    },
    data: "newtemplate",
    action: `${ENV.API_ROOT}/NaocDailyProduction/ImportNaocDailyProductionExcel?data=${naocDailyProductionStore.sheetName}`,

    onChange(info) {
      try {
        const { status } = info.file;

        if (status === "done") {
          const { productionData, errors } = info.file.response;
          naocDailyProductionStore.initFormaData = productionData;
          if (errors.length) {
            naocDailyProductionStore.uploadErrors = errors;

            naocDailyProductionStore.selTab = "2";
          } else {
            naocDailyProductionStore.uploadDate = moment(
              productionData.productionDate
            )._d;
            naocDailyProductionStore.uploadErrors = [];
            naocDailyProductionStore.selTab = "1";
            naocDailyProductionStore.initFormaData = productionData;
          }
        } else if (status === "error") {
          naocDailyProductionStore.showUploadErrorMessage = true;
          message.error(`${info.file.name} file preview failed.`);
          notification.error({
            message: "SPARS Feedback",
            description: `${info.file.response}`,
          });
        }
      } catch (error) {
        message.error(`${info.file.name} file preview failed.`);
      }
    },
  };
  return (
    <Drawer
      title={
        <>
          <CloudUploadOutlined styel={{ color: "red" }} />{" "}
          <span>{`NAOC JV  OPERATIONS 100% FLASH PRODUCTION UPLOAD for ${moment(
            naocDailyProductionStore.uploadDate
          ).format("DD-MMM-YYYY")}`}</span>
        </>
      }
      visible={naocDailyProductionStore.showNaocDailyProductionDialog}
      onClose={() => {
        naocDailyProductionStore.showNaocDailyProductionDialog = false;
      }}
      width={"80%"}
      destroyOnClose={true}
      drawerStyle={{ borderTop: "5px solid #F29C1F" }}
    >
      <div className="ms-Grid" dir="ltr" style={{ padding: "10px" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm4">
                  <Radio.Group
                    buttonStyle="solid"
                    value={naocDailyProductionStore.view}
                    onChange={({ target }) => {
                      naocDailyProductionStore.view = target.value;
                    }}
                  >
                    <Radio.Button value="upload">
                      Input Deck Upload
                    </Radio.Button>
                    <Radio.Button value="manual">
                      Production Data Entry
                    </Radio.Button>
                  </Radio.Group>
                </div>

                <div className="ms-Grid-col ms-sm4">
                  {naocDailyProductionStore.view === "upload" && (
                    <>
                      <div style={{ textAlign: "center" }}>
                        {" "}
                        <span style={{ color: "red" }}>
                          Don't have NAOC Daily Production Input Deck?
                        </span>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <Tooltip title="click to download  100% flash production  template for NAOC JV production operations.">
                          <Link
                            underline={true}
                            style={{ textDecoration: "underline" }}
                            onClick={async () => {
                              try {
                                await naocDailyProductionStore.DownlaodDailyProductionTemplate();
                              } catch (error) {
                                notification.error({
                                  message: "SPARS Feedback",
                                  description: error.message,
                                });
                              }
                            }}
                          >
                            Download flash production input deck
                          </Link>
                        </Tooltip>
                      </div>
                    </>
                  )}
                </div>

                <div
                  className="ms-Grid-col ms-sm4"
                  style={{ textAlign: "right" }}
                >
                  <Space>
                    <Button
                      type="primary"
                      disabled={!naocDailyProductionStore.isValidProductionData}
                      icon={<Save className="bicon" />}
                      onClick={async () => {
                        try {
                          const retVal =
                            await naocDailyProductionStore.saveDailyProduction(
                              naocDailyProductionStore.initFormaData
                            );
                          if (retVal.success) {
                            naocDailyProductionStore.showNaocDailyProductionDialog = false;
                            let prod = retVal.production;
                            message.success(
                              `Production Data upload for ${moment(
                                naocDailyProductionStore.uploadDate
                              ).format("dddd DD-MMM-YYYY")} was sucessfull`
                            );
                            naocDailyProductionStore.dailyProductions.set(
                              prod.naocDailyProductionId,
                              {
                                ...prod,
                                modifiedProductionDate: moment(
                                  prod.productionDate
                                ).format("ddd DD-MMM-YYYY"),
                                strippedSARemarks: prod.swampAreaRemarks
                                  ? prod.swampAreaRemarks.replace(
                                      /(<([^>]+)>)/gi,
                                      " "
                                    )
                                  : null,
                                strippedLARemarks: prod.landAreaRemarks
                                  ? prod.landAreaRemarks.replace(
                                      /(<([^>]+)>)/gi,
                                      " "
                                    )
                                  : null,
                              }
                            );
                          } else {
                            notification.error({
                              message: "SPARS Feedback",
                              description: retVal.message,
                            });
                          }
                        } catch (error) {
                          notification.error({
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        }
                      }}
                    >
                      Save
                    </Button>
                  </Space>
                </div>
              </div>
            </div>
          </div>
        </div>
        {naocDailyProductionStore.isDownloadingTemplate && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="downloading template,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}
        {naocDailyProductionStore.isSaving && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="saving production data,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}

        {naocDailyProductionStore.showUploadErrorMessage && (
          <MessageBar
            type={MessageBarType.blocked}
            styles={{ root: { backgroundColor: "rgb(253, 231, 233)" } }}
            truncated={true}
            isMultiline={false}
          >
            This error may occur due to alteration of the standard upload
            template like inserting rows and columns in the upload workbook,
            thereby distorting the cell adresses, this can be resolved by
            mapping the cell adresses correctly.
            <Link href="/main/administration/settings">Go to Mapping.</Link>
          </MessageBar>
        )}
      </div>

      {naocDailyProductionStore.view === "upload" ? (
        <Layout style={{ background: "#fff" }}>
          <Content style={{ background: "#fff" }}>
            <Layout>
              <Sider
                width={300}
                style={{
                  background: "#F0F2F5",
                  height: "100vh",
                  padding: "10px",
                }}
              >
                <div className="ms-Grid" dir="ltr">
                  <div
                    className="ms-Grid-row"
                    style={{ background: "#F0F2F5" }}
                  >
                    <div className="ms-Grid-col ms-sm12">
                      {" "}
                      <SubPageHeaderTitle title="Browse Pane" />
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                      <Form layout="vertical">
                        <Form.Item
                          label={
                            <span style={{ color: "red" }}>
                              Production Refer Date *
                            </span>
                          }
                        >
                          <Tooltip title="NAOC JV operations daily flash production date">
                            <DatePicker
                              value={toAntPickerDate(naocDailyProductionStore?.uploadDate)}
                              onChange={(date, dateString) => {
                                if (date) {
                                  naocDailyProductionStore.uploadDate = getPickerDate(date);
                                  let dateVal = date.format(
                                    "YYYY-MM-DDT00:00:00.000Z"
                                  );

                                  naocDailyProductionStore.initFormaData.productionDate =
                                    dateVal;
                                }
                              }}
                              style={{ width: "100%" }}
                              defaultValue={toAntPickerDate(new Date())}
                              format={"DD-MMM-YYYY"}
                              locale={"en_US"}
                            />
                          </Tooltip>
                        </Form.Item>

                        <Form.Item
                          label={
                            <span style={{ color: "red" }}>
                              Input Deck WorkSheet *
                            </span>
                          }
                        >
                          <Tooltip title="enter the sheetname where the flash production is located in the browsed workbook e.g DailyProductionTemplate">
                            <Input
                              placeholder="Worksheet Name"
                              value={naocDailyProductionStore.sheetName}
                              onChange={({ target }) => {
                                naocDailyProductionStore.sheetName =
                                  target.value;
                              }}
                            />
                          </Tooltip>
                        </Form.Item>
                        <Form.Item>
                          <Dragger
                            style={{
                              width: "100%",
                              backgroundColor: "transparent",
                            }}
                            multiple={false}
                            {...uploadprops}
                          >
                            <p className="ant-upload-drag-icon">
                              <FileExcelOutlined style={{ color: "#68D391" }} />
                            </p>
                            <p className="ant-upload-text">
                              Browse for Flash Production Input Deck
                            </p>
                          </Dragger>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </Sider>
              <Content style={{ background: "#F0F2F5" }}>
                <div
                  className="ms-Grid"
                  dir="ltr"
                  style={{ background: "white" }}
                >
                  <Pivot
                    linkSize={PivotLinkSize.normal}
                    selectedKey={naocDailyProductionStore.selTab}
                    onLinkClick={(item, ev) => {
                      naocDailyProductionStore.selTab = item.props.itemKey;
                    }}
                  >
                    <PivotItem
                      headerText="Field Production and Evacuation Data"
                      itemKey="1"
                    >
                      <div
                        className="ms-Grid-row"
                        style={{ background: "white" }}
                      >
                        <CommandBar
                          items={[
                            {
                              key: "clear",
                              text: "Clear Entries",
                              onRenderIcon: () => <X />,
                              onClick: () => {
                                naocDailyProductionStore.initFormaData =
                                  initData;
                                naocDailyProductionStore.uploadDate = moment(
                                  new Date()
                                );
                                naocDailyProductionStore.showNaocDailyProductionDialog =
                                  "";
                                naocDailyProductionStore.showNaocDailyProductionDialog = true;
                              },
                            },
                          ]}
                        />
                      </div>

                      <NaocDailyProductionForm />
                    </PivotItem>
                    <PivotItem
                      headerText="Deck Upload Data Validation"
                      itemKey="2"
                      onRenderItemLink={(link, defaultRenderer) => (
                        <span>
                          <InfoCircleOutlined style={{ color: "red" }} />{" "}
                          {defaultRenderer(link)}{" "}
                          <Badge
                            count={naocDailyProductionStore.uploadErrors.length}
                          />
                        </span>
                      )}
                    >
                      <ErrorLogs />
                    </PivotItem>
                  </Pivot>
                </div>
              </Content>
            </Layout>
          </Content>
        </Layout>
      ) : (
        <ManualFormEntry />
      )}
    </Drawer>
  );
});

